/* One effective marketing decision for acquisition and Fingerprint. Never changes consent. */
(function (win) {
  if (win.plungeAttributionPermission) return;
  win.plungeAttributionPermission = function () {
    function result(state, reason) { return { state: state, reason: reason }; }
    if (win.navigator.globalPrivacyControl === true) return result('denied', 'gpc');
    try {
      var cp = win.Shopify && win.Shopify.customerPrivacy;
      if (!cp || typeof cp.currentVisitorConsent !== 'function' || typeof cp.marketingAllowed !== 'function') return result('pending', 'shopify_not_ready');
      var choice = cp.currentVisitorConsent() || {};
      if (choice.marketing === 'no' || choice.sale_of_data === 'no') return result('denied', 'shopify_opt_out');
      var cmp = win.Consentmo;
      if (!cmp || typeof cmp.currentVisitorConsent !== 'function' || typeof cmp.getStatus !== 'function') return result('pending', 'cmp_not_ready');
      var cmpChoice = cmp.currentVisitorConsent(), status = cmp.getStatus();
      if (cmpChoice && cmpChoice.marketing === false || status === 'decline' || status === 'do_not_sell') return result('denied', 'cmp_opt_out');
      // Effective Shopify permission applies the merchant's regional default and saved choice.
      // Empty raw preferences do not mean refusal. Unknown is not a grant or revocation.
      var effective = cp.marketingAllowed();
      var sale = typeof cp.saleOfDataAllowed === 'function' ? cp.saleOfDataAllowed() : undefined;
      var region = typeof cp.getRegion === 'function' ? cp.getRegion() : '';
      if (sale === false) return result('denied', 'sale_of_data_opt_out');
      if (choice.marketing !== 'yes' && !region) return result('pending', 'region_not_ready');
      if (effective === true) return result('allowed', choice.marketing === 'yes' ? 'explicit_choice' : 'effective_site_policy');
      if (effective === false) return result('denied', 'effective_site_policy');
      return result('pending', 'permission_not_ready');
    } catch (_) { return result('pending', 'consent_sdk_not_ready'); }
  };
})(window);

/* DTC acquisition only; no marketing/form/conversion events. */
(function(){
// attribution-core.mjs
/** Staged, side-effect-free attribution core. No cookies, DOM, network or automatic execution.
 * The publisher must supply the existing consent decision and verified form mapping.
 */
const UTM_KEYS = Object.freeze(['utm_source','utm_medium','utm_campaign','utm_term','utm_content','utm_id']);
const CLICK_KEYS = Object.freeze(['gclid','gbraid','wbraid','twclid','fbclid','twclid','li_fat_id']);
// Verified Form 20 schema keys only. This confirms field existence, not Make/Salesforce mapping.
// The legacy click mapping remains opt-in until its downstream semantics are verified.
const COGNITO_FORM20_FIELDS = Object.freeze({
  landingUrl:'WebsiteUrl', utm_source:'Utmsource', utm_medium:'Utmmedium',
  utm_campaign:'Utmcampaign', utm_term:'Utmterm', utm_content:'Utmcontent', utm_id:'Utmid'
});
const COGNITO_FORM20_LEGACY_CLICK_FIELD = 'Fbclid';
const DIMENSION_KEYS = Object.freeze(['meta_campaign_id','meta_adset_id','meta_ad_id','google_campaign_id','google_adgroup_id','google_ad_id','google_keyword','google_target_id','google_match_type','meta_adset_name','meta_placement']);
const TRACKING_KEYS = [...UTM_KEYS, ...CLICK_KEYS, ...DIMENSION_KEYS];
const PARAMETER_ALIASES = Object.freeze({fbadid:'meta_ad_id'});
const INTERNAL_HOSTS = new Set(['plunge.com','www.plunge.com','business.plunge.com']);
const INTERNAL_CAMPAIGNS = new Set(['menu','menu_contact','menu_military','menu_commercial','menu_fitness','menu_hospitality','menu_sports','menu_real']);
const isPlungePreviewHost=host=>host==='2cgh85fki77njwal-63483871385.shopifypreview.com';
const copy = value => value == null ? value : JSON.parse(JSON.stringify(value));
const blank = () => Object.fromEntries(TRACKING_KEYS.map(key => [key, null]));

function parseTouch(href, {consentAllowed = false, capturedAt, touchId,previewHost=null} = {}) {
  if (consentAllowed !== true) return {kind:'suppressed', reason:'consent-not-confirmed'};
  let url;
  try { url = new URL(href); } catch { return {kind:'rejected',reason:'invalid-url'}; }
  if (url.protocol !== 'https:' || (!INTERNAL_HOSTS.has(url.hostname)&&!(url.hostname===previewHost&&isPlungePreviewHost(previewHost))))
    return {kind:'rejected', reason:'unexpected-origin'};
  if (!/^[a-zA-Z0-9_-]{1,64}$/.test(touchId || '') || !Number.isFinite(Date.parse(capturedAt))) throw new Error('A touch ID and valid timestamp are required');
  const fields = blank(), seen = new Set(), repairs = [], provenance = {};
  for (const [rawKey, value] of url.searchParams) {
    // Recover the observed ??utm_source form only; reject conflicting duplicates.
    const parameter = rawKey.replace(/^\?+/, '');
    const key = PARAMETER_ALIASES[parameter] || parameter;
    if (!TRACKING_KEYS.includes(key)) continue;
    if(rawKey.length>64) return {kind:'rejected',reason:'invalid-tracking-key',key};
    if (seen.has(key)) return {kind:'rejected', reason:'duplicate-tracking-key', key};
    seen.add(key);
    const limit = ['meta_campaign_id','meta_adset_id','meta_ad_id','google_campaign_id','google_adgroup_id','google_ad_id'].includes(key) ? 64 : key==='google_target_id' ? 128 : 255;
    if (value.length > limit || /[\u0000-\u001f\u007f]/.test(value))
      return {kind:'rejected', reason:'invalid-tracking-value', key};
    if (['meta_campaign_id','meta_adset_id','meta_ad_id'].includes(key) && value && !/^\d+$/.test(value))
      return {kind:'rejected', reason:'invalid-platform-id', key};
    fields[key] = value.trim() || null;
    if(fields[key]) provenance[key]={method:'named-url-parameter',parameter:rawKey};
    if (parameter !== rawKey) repairs.push(key);
  }
  const source = (fields.utm_source || '').toLowerCase();
  const internal = INTERNAL_HOSTS.has(source) && fields.utm_medium === 'referral' && INTERNAL_CAMPAIGNS.has(fields.utm_campaign);
  if (internal) {
    // An explicit click ID combined with internal tags needs investigation, not a guess.
    if (CLICK_KEYS.some(k=>fields[k])) return {kind:'rejected', reason:'internal-tags-with-click-id'};
    return {kind:'internal', navigation:fields.utm_campaign};
  }
  if (!TRACKING_KEYS.some(k=>fields[k])) return {kind:'direct'};
  return {kind:'external', touch:{id:touchId,capturedAt,landingUrl:url.origin+url.pathname,
    fields,provenance,repairs,method:'url',consent:'allowed-by-existing-policy'}};
}

function advanceState(previous, parsed, {consentAllowed = false, now, maxAgeMs} = {}) {
  if (consentAllowed !== true) return null;
  if (!Number.isFinite(now) || !Number.isFinite(maxAgeMs) || maxAgeMs <= 0) throw new Error('Existing retention policy must be supplied');
  const alive = touch => touch && Number.isFinite(Date.parse(touch.capturedAt)) &&
    Date.parse(touch.capturedAt) <= now && now-Date.parse(touch.capturedAt) < maxAgeMs;
  let state = {first:alive(previous?.first)?copy(previous.first):null, latest:alive(previous?.latest)?copy(previous.latest):null};
  if (parsed.kind === 'external' && alive(parsed.touch)) {
    state.first ||= copy(parsed.touch);
    state.latest = copy(parsed.touch); // Replace atomically. Never borrow fields from an older touch.
  }
  return state;
}

function selectLegacyClick(touch) {
  if (!touch) return null;
  const fields = touch.fields;
  const candidates = CLICK_KEYS.filter(k=>fields[k]);
  // A legacy untyped field cannot safely represent simultaneous platform identities.
  if (candidates.length !== 1) return null;
  const type = candidates[0];
  return {type,value:fields[type]};
}

function cognitoPayload(touch, verifiedFieldMap) {
  if (!touch) return {};
  const payload = {};
  for (const key of TRACKING_KEYS) {
    const target = verifiedFieldMap[key];
    if (target && touch.fields[key] !== null) payload[target] = touch.fields[key];
  }
  if (verifiedFieldMap.landingUrl) payload[verifiedFieldMap.landingUrl] = touch.landingUrl;
  // Compatibility only: Form 20's Fbclid field is labeled Clickid in the verified schema.
  // Its downstream Make/Click_ID mapping is unverified and must be confirmed before enabling.
  // Typed fields remain separate in the touch; Form 20 has no separate typed-click fields.
  const click = selectLegacyClick(touch);
  if (verifiedFieldMap.legacyClick && click) payload[verifiedFieldMap.legacyClick] = click.value;
  return payload;
}

function handoffUrl(href, touch, {consentAllowed = false, destination = 'internal'} = {}) {
  const url = new URL(href);
  const internal = url.protocol === 'https:' && INTERNAL_HOSTS.has(url.hostname);
  const calendly = url.protocol === 'https:' && url.hostname === 'calendly.com' &&
    ['/d/cwwj-9gg-s9m','/d/cwv5-dyy-zqr/plunge-for-business'].includes(url.pathname);
  if (!(destination === 'internal' && internal) && !(destination === 'calendly' && calendly))
    throw new Error('Destination not approved');
  // Calendly's inspected public widget exposes these five UTMs. Do not invent utm_id support.
  // No click IDs, contact fields, or arbitrary query values are copied to Calendly.
  const keys = destination === 'calendly' ? UTM_KEYS.filter(k=>k!=='utm_id') : TRACKING_KEYS;
  for (const k of [...url.searchParams.keys()]) {
    const parameter=k.replace(/^\?+/, '');
    if (TRACKING_KEYS.includes(parameter) || Object.hasOwn(PARAMETER_ALIASES,parameter)) url.searchParams.delete(k);
  }
  if (consentAllowed !== true || !touch) return url.href;
  for (const k of keys) if (touch.fields[k] && (destination!=='calendly' || touch.fields[k].length<255)) url.searchParams.set(k,touch.fields[k]);
  return url.href;
}

// capture-adapter.mjs

// Proposed names are enabled only after schema read-back proves their exact keys.
const TYPED_FIELDS = Object.freeze({gclid:'GoogleGclid',gbraid:'GoogleGbraid',wbraid:'GoogleWbraid',fbclid:'MetaFbclid',meta_campaign_id:'MetaCampaignId',meta_adset_id:'MetaAdsetId',meta_ad_id:'MetaAdId',google_campaign_id:'GoogleCampaignId',google_adgroup_id:'GoogleAdgroupId',google_ad_id:'GoogleAdId',google_keyword:'GoogleKeyword'});
function verifiedMap(schema) {
  const props=schema?.properties || {};
  return Object.fromEntries(Object.entries({...COGNITO_FORM20_FIELDS,...TYPED_FIELDS}).filter(([,v])=>Object.hasOwn(props,v)));
}
function keywordId(raw) {
  const parts=String(raw||'').split(':').filter(s=>/^kwd-\d+$/.test(s));
  return parts.length===1 ? parts[0] : null;
}
function consentDecision(customerPrivacy, navigator) {
  if(navigator?.globalPrivacyControl===true) return false;
  try { return customerPrivacy?.currentVisitorConsent?.().marketing==='yes'; } catch { return false; }
}
function consentEvidence(customerPrivacy,navigator,{policyVersion,observedAtUTC}) {
  const allowed=consentDecision(customerPrivacy,navigator);
  let evidenceReference=null;
  try { evidenceReference=customerPrivacy?.consentId?.()||null; } catch {}
  // Shopify's marketing decision supports this attribution gate only. It is
  // not evidence of subscriptions or Google's distinct advertising purposes.
  const purposes={
    marketing_attribution:{state:allowed?'allowed':'unknown',evidenceReference,observedAtUTC},
    sms_subscription:{state:'unknown'},
    email_subscription:{state:'unknown'},
    ad_user_data:{state:'unknown'},
    ad_personalization:{state:'unknown'}
  };
  try {
    if(navigator?.globalPrivacyControl===true || customerPrivacy?.currentVisitorConsent?.().marketing==='no') purposes.marketing_attribution.state='denied';
  } catch {}
  return {allowed,evidenceReference,policyVersion,capturedAtUTC:observedAtUTC,timeMeaning:'decision-observed-at',purposes};
}
function purposeEvidence(consent) {
  const result={};
  for(const key of ['marketing_attribution','sms_subscription','email_subscription','ad_user_data','ad_personalization']) {
    const actual=consent.purposes?.[key];
    // Non-attribution purposes need their own actual evidence and timestamp.
    if(actual && ['allowed','denied'].includes(actual.state) && actual.evidenceReference && Number.isFinite(Date.parse(actual.observedAtUTC))) {
      result[key]={state:actual.state,evidenceReference:actual.evidenceReference,observedAtUTC:actual.observedAtUTC};
    } else result[key]={state:'unknown'};
  }
  return result;
}
function consentSource(source) {
  if(source?.system!=='Consentmo')return undefined;
  const result={system:'Consentmo',choiceMechanism:'not-exposed-by-sdk'};
  if(['cmp-effective-permission','cmp-reported-choice'].includes(source.permissionBasis))result.permissionBasis=source.permissionBasis;
  if(['accept_all','allow','decline','do_not_sell','unknown'].includes(source.reportedStatus))result.reportedStatus=source.reportedStatus;
  if(typeof source.configurationVersion==='string'&&source.configurationVersion.length<=200)result.configurationVersion=source.configurationVersion;
  if(typeof source.gpcObserved==='boolean')result.gpcObserved=source.gpcObserved;
  if(['gpc','cmp-opt-out','cmp-effective-permission-not-allowed','none'].includes(source.captureSuppression))result.captureSuppression=source.captureSuppression;
  return result;
}
function safeTouch(touch) {
  if(!touch) return null;
  const fields=Object.fromEntries(TRACKING_KEYS.map(k=>[k,touch.fields?.[k] ?? null]));
  const url=new URL(touch.landingUrl);
  return {touchId:touch.id,capturedAtUTC:touch.capturedAt,landingUrl:url.origin+url.pathname,fields,method:'url',provenance:Object.fromEntries(TRACKING_KEYS.filter(k=>fields[k]).map(k=>[k,touch.provenance?.[k] || {method:'named-url-parameter',parameter:k}]))};
}
function validateStoredState(value,{previewHost=null}={}) {
  const validate=touch=>{
    if(!touch || typeof touch!=='object' || !touch.fields || typeof touch.fields!=='object') return null;
    try {
      const url=new URL(touch.landingUrl);
      if(url.search || url.hash || url.username || url.password) return null;
      for(const k of TRACKING_KEYS) {
        const v=touch.fields[k];
        if(v!=null && typeof v!=='string') return null;
        if(v) {
          const source=touch.provenance?.[k];
          const parameter=source?.parameter||k;
          const normalized=parameter.replace(/^\?+/, '');
          if(parameter.length>64 || (source && source.method!=='named-url-parameter') || (normalized!==k && PARAMETER_ALIASES[normalized]!==k)) return null;
          url.searchParams.set(parameter,v);
        }
      }
      const parsed=parseTouch(url.href,{consentAllowed:true,capturedAt:touch.capturedAt,touchId:touch.id,previewHost});
      return parsed.kind==='external'?parsed.touch:null;
    } catch {return null;}
  };
  return {first:validate(value?.first),latest:validate(value?.latest)};
}
function formPayload(state, schema, consent) {
  const map=verifiedMap(schema), props=schema?.properties||{};
  // Explicit blanks clear stale prefill after withdrawal, expiry or a changed tuple.
  const result=Object.fromEntries(Object.values(map).map(k=>[k,'']));
  for(const k of ['GoogleKeywordId','AttributionTouchId','AttributionEvidence']) if(Object.hasOwn(props,k)) result[k]='';
  const denied=consent?.explicitRevocation===true && ['marketing_attribution','ad_user_data'].some(k=>consent.purposes?.[k]?.state==='denied');
  if(consent?.allowed!==true && !denied) return result;
  if(denied) state=null; // Revocation envelope carries no fresh acquisition use.
  if(state?.first) Object.assign(result,cognitoPayload(state.first,map));
  for(const [k,v] of Object.entries(result)) {
    const limit=props[k]?.maxLength ?? (k.endsWith('Id')?64:255);
    if(typeof v!=='string' || v.length>limit) result[k]='';
  }
  if(Object.hasOwn(props,'GoogleKeywordId') && state?.first) result.GoogleKeywordId=keywordId(state.first.fields.google_target_id)||'';
  if(Object.hasOwn(props,'AttributionTouchId') && state?.first) result.AttributionTouchId=state.first.id;
  if(Object.hasOwn(props,'AttributionEvidence')) {
    if(!consent.policyVersion || !consent.evidenceReference || !Number.isFinite(Date.parse(consent.capturedAtUTC))) return result;
    // Consent evidence is meaningful without a tagged touch: a legitimate
    // email-only enhanced-conversion path must not require fabricated click IDs.
    const evidence=JSON.stringify({schemaVersion:1,first:safeTouch(state?.first),latest:safeTouch(state?.latest),consent:{purpose:'marketing-attribution',state:consent.purposes?.marketing_attribution?.state==='denied'?'denied':'allowed',evidenceReference:consent.evidenceReference,policyVersion:consent.policyVersion,capturedAtUTC:consent.capturedAtUTC,timeMeaning:consent.timeMeaning||'decision-observed-at',purposes:purposeEvidence(consent),source:consentSource(consent.source)}});
    if(evidence.length<=Math.min(32768,props.AttributionEvidence.maxLength||32768)) result.AttributionEvidence=evidence;
  }
  return result;
}

// No automatic startup: publisher must supply verified retention and storage policy.
// Store interface can be existing consent-aware first-party storage; no invented cookie scope.
function createCapture({store,now=Date.now,id,retentionMs,schema,getConsent,prefill,previewHost=null}) {
  if(!Number.isFinite(retentionMs)||retentionMs<=0) throw new Error('Verified retention required');
  let state=null;
  function update(href) {
    const consent=getConsent();
    if(consent?.allowed!==true) {
      state=null; if(consent?.pending!==true)store.remove(); prefill(formPayload(null,schema,consent)); return null;
    }
    const at=now();
    let stored=null;
    try { stored=validateStoredState(store.read(),{previewHost}); } catch { store.remove(); }
    const parsed=parseTouch(href,{consentAllowed:true,capturedAt:new Date(at).toISOString(),touchId:id(),previewHost});
    state=advanceState(stored,parsed,{consentAllowed:true,now:at,maxAgeMs:retentionMs});
    if(state.first) store.write(state); else store.remove();
    prefill(formPayload(state,schema,consent));
    return structuredClone(state);
  }
  return {update,getState:()=>structuredClone(state)};
}

// browser-storage.mjs
// Existing site policy observed seven-day cookies at .plunge.com; caller supplies
// that approved duration explicitly. No legacy per-field cookie is imported.
function cookieStore(document,hostname,retentionMs,{previewHost=null}={}) {
  const preview=hostname===previewHost&&isPlungePreviewHost(previewHost);
  if(!['plunge.com','www.plunge.com','business.plunge.com'].includes(hostname)&&!preview) throw new Error('Unsupported host');
  if(!Number.isFinite(retentionMs)||retentionMs<=0) throw new Error('Retention required');
  const keys={first:'plunge_attribution_v1_first',latest:'plunge_attribution_v1_latest'};
  const expire=key=>{for(const domain of ['', '; domain=.plunge.com','; domain='+hostname]) document.cookie=key+'=; path=/; max-age=0; SameSite=Lax; Secure'+domain;};
  return {
    read() {
      const pairs=new Map(document.cookie.split(';').map(s=>s.trim().split(/=(.*)/s).slice(0,2)));
      const state={};
      for(const [kind,key] of Object.entries(keys)) state[kind]=pairs.get(key)?JSON.parse(decodeURIComponent(pairs.get(key))):null;
      return state;
    },
    write(state) {
      for(const [kind,key] of Object.entries(keys)) {
        if(!state[kind]) {expire(key);continue;}
        const encoded=encodeURIComponent(JSON.stringify(state[kind]));
        if(encoded.length>3600) {expire(key);continue;}
        // Retention is measured from original capture, never refreshed by navigation.
        const expires=new Date(Date.parse(state[kind].capturedAt)+retentionMs).toUTCString();
        document.cookie=key+'='+encoded+'; path=/;'+(preview?'':' domain=.plunge.com;')+' expires='+expires+'; SameSite=Lax; Secure';
      }
    },
    remove() {Object.values(keys).forEach(expire);}
  };
}

function clearLegacyAttribution(document,storage,hostname) {
  const old=['fbclid','gclid','li_fat_id','utm_source','utm_medium','utm_campaign','utm_term','utm_content','utm_id'];
  for(const name of [...old,...old.map(k=>'plunge_'+k)]) {
    for(const domain of ['', '; domain=.plunge.com','; domain='+hostname]) document.cookie=name+'=; path=/; max-age=0; SameSite=Lax; Secure'+domain;
  }
  for (const key of ['fbclid','gclid']) try { storage?.removeItem(key); } catch {}
}

// consentmo-reader.mjs
// Bound to task-13's installed SDK v1.0.0/native configuration evidence.
// No settings, consent choices, subscriptions or GCM signals are written.
function readConsentmoConsent(win,{nowUTC,eventName}={}) {
 const unknown={allowed:false,explicitRevocation:false,purposes:{marketing_attribution:{state:'unknown'},ad_user_data:{state:'unknown'},ad_personalization:{state:'unknown'},email_subscription:{state:'unknown'},sms_subscription:{state:'unknown'}}};
 const permission=win.plungeAttributionPermission?.() || {state:'pending',reason:'reader_not_ready'};
 if(permission.state==='pending')return {...unknown,pending:true};
 const cmp=win.Consentmo;
 let permissions,status;
 try{permissions=cmp?.currentVisitorConsent?.();status=cmp?.getStatus?.();}catch{return {...unknown,pending:true};}
 const gpc=win.navigator?.globalPrivacyControl===true;
 const optedOut=permission.state==='denied';
 const allowed=permission.state==='allowed';
 const decision=typeof permissions?.marketing==='boolean'?permissions.marketing:null;
 const result={...unknown,allowed,capturedAtUTC:nowUTC,timeMeaning:'decision-observed-at',permissionBasis:decision===null?'cmp-effective-permission':'cmp-reported-choice'};
 result.source={system:'Consentmo',permissionBasis:result.permissionBasis,choiceMechanism:'not-exposed-by-sdk',reportedStatus:['accept_all','allow','decline','do_not_sell'].includes(status)?status:'unknown',gpcObserved:gpc,captureSuppression:gpc?'gpc':optedOut?'cmp-opt-out':'none'};
 const v=cmp?.version;
 if((typeof v==='string'&&v.length>0&&v.length<=200)||(typeof v==='number'&&Number.isFinite(v))){result.policyVersion='consentmo:'+String(v);result.source.configurationVersion=String(v);}
 // Existing enabled Shopify bridge can provide its real audit reference, but
 // only when current category values agree. Availability is runtime-checked.
 if(decision!==null&&!(decision===true&&optedOut)){
  try{
   const privacy=win.Shopify?.customerPrivacy;
   const synced=privacy?.currentVisitorConsent?.().marketing;
   const id=privacy?.consentId?.();
   if(synced===(decision?'yes':'no')&&typeof id==='string'&&id.length>0&&id.length<=512){
    result.evidenceReference=id;
    result.purposes.marketing_attribution={state:decision?'allowed':'denied',evidenceReference:id,observedAtUTC:nowUTC};
    result.explicitRevocation=!decision&&['consentmoSignal','consentmoSignal_onLoad','visitorConsentCollected'].includes(eventName);
   }
  }catch{}
 }
 // GCMv2 OFF is not denial. Actual ad-data purpose/recipient/record coverage
 // remains unverified; inactive mappings or implied-mode labels supply no grant.
 return result;
}

// dtc-acquisition.mjs

// Acquisition only. No form hooks, scheduling, ad events, identity matching,
// consent settings, GCM updates, customer data or external requests.
function installDtcAcquisition(win,{now=Date.now}={}) {
 if(win.__plungeDtcAcquisitionV1)return win.__plungeDtcAcquisitionV1;
 if(win.Shopify?.shop!=='reboot-labs.myshopify.com'||!['plunge.com','www.plunge.com'].includes(win.location.hostname))return null;
 const doc=win.document,entryHref=win.location.href;
 const store=cookieStore(doc,win.location.hostname,31536000000);
 let captured=false,lastPermission,disposed=false;
 const getConsent=()=>readConsentmoConsent(win,{nowUTC:new Date(now()).toISOString()});
 const capture=createCapture({store,now,id:()=>win.crypto.randomUUID(),retentionMs:31536000000,schema:{properties:{}},getConsent,prefill(){}});
 function refresh(){
  if(disposed)return;
  const consent=getConsent();
  try{
   capture.update(captured?win.location.origin+win.location.pathname:entryHref);
   if(consent.allowed)captured=true;
   else if(!consent.pending)clearLegacyAttribution(doc,win.localStorage,win.location.hostname);
  }catch{}
  lastPermission=String(consent.allowed)+':'+String(consent.pending);
 }
 const events=['consentmoSignal','consentmoSignal_onLoad','visitorConsentCollected'];
 events.forEach(name=>doc.addEventListener(name,refresh));
 refresh();let attempts=0;
 const timer=win.setInterval(()=>{const c=getConsent();if(String(c.allowed)+':'+String(c.pending)!==lastPermission)refresh();if(++attempts>=120)win.clearInterval(timer);},250);
 const api={refresh,getState:()=>capture.getState(),dispose(){disposed=true;win.clearInterval(timer);events.forEach(name=>doc.removeEventListener(name,refresh));}};
 win.__plungeDtcAcquisitionV1=api;return api;
}

installDtcAcquisition(window);
})();
